module.exports = __webpack_public_path__ + "static/media/1_A1_16.ec996c75.png";